"use client";

import { c as _c } from "react/compiler-runtime";
import { useTenant } from "@/contexts/tenant-provider";
import { getWindowBaseURL } from "@/lib/get-base-url";
export function useInPersonForm() {
  const $ = _c(2);
  const {
    tenant
  } = useTenant();
  let t0;
  if ($[0] !== tenant?.subDomain) {
    const openInPersonForm = (patientId, forms, membershipId, tab) => {
      const baseUrl = getWindowBaseURL(tenant?.subDomain);
      let url;
      if (forms.length === 1) {
        const encodedPath = encodeURIComponent(forms[0].pathName);
        url = `${baseUrl}/check-in/forms/fill/${encodedPath}?patientId=${encodeURIComponent(patientId)}`;
        if (membershipId) {
          url = url + `&membershipId=${encodeURIComponent(membershipId)}`;
        }
      } else {
        const params = new URLSearchParams();
        forms.forEach(f => params.append("forms", f.pathName));
        params.set("patientId", patientId);
        if (membershipId) {
          params.set("membershipId", membershipId);
        }
        url = `${baseUrl}/check-in/forms/fill?${params.toString()}`;
      }
      if (tab) {
        tab.location.href = url;
        return;
      }
      window.open(url, "_blank");
    };
    t0 = {
      openInPersonForm
    };
    $[0] = tenant?.subDomain;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}